import {
  JhTableBody,
  JhTableCell,
  JhTableHead,
  JhTableHeader,
  JhTableRow
} from "designPackages/tablePackage";
import { JhText } from "designPackages/textPackage";
import BaseTable from "./BaseTable";
import { TransactionStatusBadge } from "../utils/statusBadgeUtils";
import Image from "next/image";

interface ReservedCreditsData {
  jobTitle: string;
  cityLocalityData: string;
  salary: string;
  openings: string;
  jobId: string;
  credits: string;
  status: string;
  jobPostingDate: string;
  jobPostingTime: string;
  companyName: string;
  [key: string]: any;
}

interface ReservedCreditsTableProps {
  transactionData: ReservedCreditsData[];
  isLoading?: boolean;
}

// Status badge logic moved to shared utils

const TableEmptyState = () => (
  <div id="th-v2-reserved-table-empty-state" className="flex flex-col items-center justify-center py-16 gap-2.5">
    <Image 
      src="/hire/transactionHistoryV2/no_reserved.png" 
      alt="no reserved credits" 
      width={100} 
      height={100} 
    />
    <JhText variant="emphasis3" color="foreground">
      No reserved credits found
    </JhText>
  </div>
);

const ReservedCreditsTable = ({
  transactionData = [],
  isLoading = false
}: ReservedCreditsTableProps) => {
  const isEmpty = !transactionData.length && !isLoading;

  return (
    <BaseTable isLoading={isLoading}>
      <JhTableHeader>
        <JhTableRow>
          <JhTableHead className="w-1/4">
            <JhText variant="subtitle4" color="muted-foreground">
              Job Details
            </JhText>
          </JhTableHead>
          <JhTableHead className="w-1/4">
            <JhText variant="subtitle4" color="muted-foreground">
              Credits Reserved
            </JhText>
          </JhTableHead>
          <JhTableHead className="w-1/4">
            <JhText variant="subtitle4" color="muted-foreground">
              Status
            </JhText>
          </JhTableHead>
          <JhTableHead className="w-1/4">
            <JhText variant="subtitle4" color="muted-foreground">
              Job Posting Date
            </JhText>
          </JhTableHead>
        </JhTableRow>
      </JhTableHeader>
      <JhTableBody>
        {isEmpty ? (
          <JhTableRow>
            <JhTableCell colSpan={4} className="text-center">
              <TableEmptyState />
            </JhTableCell>
          </JhTableRow>
        ) : (
          transactionData.map((row, index) => {
          const {
            jobTitle = "",
            cityLocalityData = "",
            salary = "",
            openings = "",
            jobId = "",
            credits = "",
            status = "",
            transactionDate = "",
            transactionTime = ""
          } = row;

          return (
            <JhTableRow key={index}>
              <JhTableCell>
                <div id={`th-v2-reserved-table-job-details-${index}`} className="space-y-1">
                  <JhText variant="subtitle4" color="foreground">
                    {jobTitle}
                  </JhText>
                  <div id={`th-v2-reserved-table-job-info-${index}`} className="space-y-0.5">
                    <JhText variant="caption2" color="muted-foreground">
                      Job ID - {jobId}
                    </JhText>
                    <JhText variant="caption2" color="muted-foreground">
                      {cityLocalityData}
                    </JhText>
                    <JhText variant="caption2" color="muted-foreground">
                      {salary ? `${salary} | ` : ""}
                      {openings}
                    </JhText>
                  </div>
                </div>
              </JhTableCell>
              <JhTableCell>
                <JhText variant="subtitle3" color="foreground">
                  {credits}
                </JhText>
              </JhTableCell>
              <JhTableCell>
                <TransactionStatusBadge status={status} />
              </JhTableCell>
              <JhTableCell>
                <div id={`th-v2-reserved-table-date-${index}`} className="space-y-1">
                  <JhText variant="subtitle4" color="foreground">
                    {transactionDate}
                  </JhText>
                  {transactionTime && (
                    <JhText variant="caption2" color="muted-foreground">
                      {transactionTime}
                    </JhText>
                  )}
                </div>
              </JhTableCell>
            </JhTableRow>
          );
        })
        )}
      </JhTableBody>
    </BaseTable>
  );
};

export default ReservedCreditsTable;
